export default {
    namespaced: true,
    state: {
        is_monitor: false,
        monitor_loaded: false,
        monitor_type: '',
        time_interval: '',
        reference_map: {},
        custom_header: [],
        is_custom_monitor: false,
        monitor_title: ''
    },
    mutations:{
        set_monitor_state(state, monitor_state) {
            state.is_monitor = monitor_state;
        },
        
        set_monitor_loaded(state, monitor_loaded) {
            state.monitor_loaded = monitor_loaded;
        },

        set_monitor(state, monitor_option) {
            state.custom_header = monitor_option.custom_header;
            state.is_custom_monitor = monitor_option.is_custom_monitor;
            state.monitor_title = monitor_option.text;
            state.monitor_type = monitor_option.value;
            state.time_interval = monitor_option.time_interval;
        },

        set_reference_map(state, new_reference_map) {
            state.reference_map = new_reference_map;
        }
    },
    actions: {          
        
    },
    getters: {
        is_monitor: state => {
            return state.is_monitor;
        },

        monitor_loaded: state => {
            return state.monitor_loaded;
        },
        
        monitor_type: state => {
            return state.monitor_type;
        },

        is_show_time_choose_field: state => {
            return state.time_interval !== 'day'
        }
    },

}